/** Fuel charge: miles beyond the free allowance × rate, rounded to the penny. */
export function calcFuelPence(miles: number, includedMiles: number, ratePence: number): number {
  if (!Number.isFinite(miles) || miles <= includedMiles) return 0;
  return Math.round((miles - includedMiles) * ratePence);
}

/** Fuel is charged on the full trip: home to venue and back again. */
export function roundTripMiles(oneWayMiles: number): number {
  if (!Number.isFinite(oneWayMiles) || oneWayMiles <= 0) return 0;
  return Math.round(oneWayMiles * 2 * 10) / 10;
}
